import { AuthService } from '../../auth/auth.service';
import { DeliveryType } from '../../coaching-base/config/delivery-type.model';
import {
    CoachingEventStatus,
    CommitmentApprovalDto,
    CommitmentDto,
    EventParticipantDto,
} from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { epicDependencies } from '../../store';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

import { ApprovalAlertInfoView } from './approval-alert-info-view.model';
import { diffItemsTransformer } from './diff-items.transformer';

export function approvalAlertInfoViewTransformer(
    approval: CommitmentApprovalDto,
    commitment: CommitmentDto,
    participants: EventParticipantDto[],
    deliveryTypes: DeliveryType[],
    metrics: MetricItem[],
): ApprovalAlertInfoView {
    if (!approval) {
        return null;
    }

    // TODO FIXME. this can be done better. just to get current user id
    const service = epicDependencies.injector.get<AuthService>(AuthService);
    const authUserId = service.user.id;

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fromParticipant =
        participants.find((e) => e.id === approval.fromUserId) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as EventParticipantDto);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const targetParticipant =
        participants.find((e) => e.id === approval.targetId) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as EventParticipantDto);

    const allApproved =
        approval.state.items.filter((e) => e.approved).length ===
        approval.diff.diffItems.length;
    const approvalPendingParticipant =
        approval.fromUserId === authUserId
            ? TranslationKeyMap._9755_YOU
            : fromParticipant.fullName;
    const approvalClosedParticipant =
        approval.targetId === authUserId
            ? TranslationKeyMap._9755_YOU
            : targetParticipant.fullName;

    /// /////// separator //////////

    const markup: ApprovalAlertInfoView = {};

    if (approval.approved == null) {
        markup.messagePrefix =
            commitment.commitmentId == null
                ? TranslationKeyMap._9756_THE_HIGHLIGHTED_ITEMS_WERE_SENT_BY
                : TranslationKeyMap._9801_THE_HIGHLIGHTED_ITEMS_WERE_UPDATED_BY;
        markup.participant = approvalPendingParticipant;
        markup.dismissible = false;
        markup.borderColor = '#d17300';
        markup.backgroundColor = '#ffedd6';
        markup.showActions = approval.targetId === authUserId;
    } else if (!allApproved) {
        markup.messagePrefix =
            TranslationKeyMap._9757_THE_HIGHLIGHTED_ITEMS_WERE_ACCEPTED_AND_DISPUTED_BY;
        markup.participant = approvalClosedParticipant;
        markup.dismissible = true;
        markup.borderColor = '#d17300';
        markup.backgroundColor = '#ffedd6';
    } else if (allApproved) {
        markup.messagePrefix =
            TranslationKeyMap._9758_THE_HIGHLIGHTED_ITEMS_WERE_ACCEPTED_BY;
        markup.participant = approvalClosedParticipant;
        markup.dismissible = true;
        markup.borderColor = '#137e0f';
        markup.backgroundColor = '#f1fff1';
    }

    markup.disputedDraftOnFromId =
        approval.approved === false &&
        approval.fromUserId === authUserId &&
        commitment &&
        // commitment.statusId === CoachingEventStatus.DRAFT;
        commitment.statusId === CoachingEventStatus.DISPUTED;
    markup.disputedDraftOnTargetId =
        approval.approved === false &&
        approval.targetId === authUserId &&
        commitment &&
        // commitment.statusId === CoachingEventStatus.DRAFT;
        commitment.statusId === CoachingEventStatus.DISPUTED;

    markup.diffItemsInfo = {
        state: approval.state.items,
        items: diffItemsTransformer(
            approval.diff.diffItems,
            deliveryTypes,
            metrics,
        ),
        from: fromParticipant,
    };

    /// /////// separator //////////

    const isRegularFlow =
        commitment.statusId === CoachingEventStatus.PENDING_CLOSE ||
        approval.diff.previousStatusId === CoachingEventStatus.PENDING_CLOSE ||
        (commitment.statusId === CoachingEventStatus.CLOSED &&
            approval.diff.previousStatusId === CoachingEventStatus.ACTIVE);

    markup.showButtons =
        isRegularFlow &&
        approval.approved == null &&
        approval.targetId === authUserId;

    // TODO revise. apparently, unlike before, it now needs to go back to decorating for both the sender and receiver
    markup.showAlert = !isRegularFlow /* &&
                (this.state.approval.fromUserId !== this._authService.user.id || this._navigatedFromNotification) */;
    // this._diffDecoratorService.decorate(this.state.approval.diff.diffItems, this.state.approval.state.items);

    markup.showSummaryDialog =
        /* _navigatedFromNotification && */
        !isRegularFlow &&
        (approval.approved != null || approval.targetId === authUserId);

    markup.decorateForm = !isRegularFlow;

    return markup;
}
